"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexColorDelta = void 0;
/* eslint-disable no-param-reassign */
var hexColorDelta = function (hex1, hex2) {
    if (hex1.indexOf('#') === 0) {
        hex1 = hex1.slice(1);
    }
    if (hex2.indexOf('#') === 0) {
        hex2 = hex2.slice(1);
    }
    var r1 = parseInt(hex1.substring(0, 2), 16);
    var g1 = parseInt(hex1.substring(2, 4), 16);
    var b1 = parseInt(hex1.substring(4, 6), 16);
    var r2 = parseInt(hex2.substring(0, 2), 16);
    var g2 = parseInt(hex2.substring(2, 4), 16);
    var b2 = parseInt(hex2.substring(4, 6), 16);
    var r = 255 - Math.abs(r1 - r2);
    var g = 255 - Math.abs(g1 - g2);
    var b = 255 - Math.abs(b1 - b2);
    r /= 255;
    g /= 255;
    b /= 255;
    return (r + g + b) / 3;
};
exports.hexColorDelta = hexColorDelta;
